<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="auto">
    <template #header>
      索赔模板
    </template>
    <template #content>
      <gj-alert type="warning" show-icon style="margin-bottom: 20px" border>
        请在对应店铺/站点的亚马逊卖家后台进行申诉，<span style="color: red">避免关联</span>；<br/>
        申诉地址：登录卖家后台 -> Help->Get support -> Selling on amzon->Or, browse for your issue in the menu -> <br/>
        <span style="padding: 0 30px;"></span>by amazon ->Inventory Shipped to Amazon (Inbound) -> Investigate Missing from Inbound Inventory
      </gj-alert>
      <el-form label-width="120px">
        <el-form-item label="店铺/国家" style="margin-bottom: 0;">
          {{claimTemplate.marketId | optionText(marketOption)}}
        </el-form-item>
        <el-form-item label="需要准备资料">
          <div>
            亚马逊货件编号：{{claimTemplate.orderId}}
            <gj-button v-copy="claimTemplate.orderId" type="primary" style="margin-left: 20px">复制</gj-button>
          </div>
          <div>库存所有权证明</div>
          <div>交货证明</div>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">关闭</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "@/minxins";
  import {mapGetters} from "vuex";
  export default {
    name: "claim-case-template",
    mixins: [modalMixIn],
    computed:{
      ...mapGetters({
        marketOption: "marketOption",
      }),
    },
    props: {
      item: null,
      claimTemplate:{
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style scoped>
  .input-case-title {
    font-size: 12px;
    color: #666;
    margin-left: 12px;
  }
  .claim-textarea {
    margin-bottom: 0;
  }
  .claim-textarea .el-textarea {
    width: 600px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
